import React, { useState, useEffect } from "react";
import { ArrowDown, ArrowUp } from "lucide-react";
import "./ScrollFloatingButton.css";

const ScrollFloatingButton = () => {
  const [isAtBottom, setIsAtBottom] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY + window.innerHeight;
      const totalHeight = document.documentElement.scrollHeight;
      // Consider "at bottom" if within 300px of page bottom
      if (totalHeight - scrollPosition <= 300) {
        setIsAtBottom(true);
      } else {
        setIsAtBottom(false);
      }
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    handleScroll();

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollClick = () => {
    if (isAtBottom) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else {
      window.scrollTo({ top: document.documentElement.scrollHeight, behavior: "smooth" });
    }
  };

  return (
    <button
      type="button"
      onClick={handleScrollClick}
      className="global-scroll-float-btn"
      aria-label={isAtBottom ? "Scroll to Top" : "Scroll to Bottom"}
    >
      {isAtBottom ? (
        <ArrowUp className="scroll-btn-icon" size={22} />
      ) : (
        <ArrowDown className="scroll-btn-icon" size={22} />
      )}
      <span className="global-scroll-tooltip">
        {isAtBottom ? "Scroll to Top" : "Scroll to Bottom"}
      </span>
    </button>
  );
};

export default ScrollFloatingButton;
